<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="setMaintProof()">
                    <span>设置凭单模板</span>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <el-table :data="maintProofRelList" max-height="500" border style="width: 100%">
                <el-table-column prop="devcMaintProofTitle" label="标题" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcMaintPeriod" label="周期" align="left" width="150"></el-table-column>
                <el-table-column prop="standard" label="参考标准" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="appliedCatNames" label="适用分类" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="80">
                    <template scope="rows">
                        <span class="swb-btn swb-btn-link" @click="deleteRel(rows.row.id)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {Utils, EventBus} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import shopDevcApi from '../../api/shopDevc'
    import {devcMaintProofForSelectDlg} from '../devcMaint/selectDlg';
    //
    export default {
        name: 'swb-devc-maint-proof-rel-list',
        desc: '设备关联的凭单',
        props: ['devcSubNoId'],
        data: function () {
            return {
                //
                maintProofRelList: []
            }
        },
        created: function () {
            //
            this.getShopDeviceMaintProofRelListBydevcSubNoId();
        },
        methods: {
            getShopDeviceMaintProofRelListBydevcSubNoId: function (item, val) {
                let self = this;
                let postData = {};
                postData.devcSubNoId = self.devcSubNoId;
                //
                let theLoad = MsgBox.loading();
                shopDevcApi.getShopDeviceMaintProofRelListBydevcSubNoId(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        self.maintProofRelList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            deleteRel: function (id) {
                let self = this;
                this.$confirm("确定要删除吗?", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    shopDevcApi.deleteShopDeviceMaintProofRel(postData, function (result) {
                        theLoad.hide();
                        if (result.type == "info") {
                            self.$message.success("操作成功");
                            self.getShopDeviceMaintProofRelListBydevcSubNoId();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            setMaintProof: function () {
                let self = this;
                let params = {
                    multiSelect: true,
                    appliedWorkType: 1 // 保养
                };
                devcMaintProofForSelectDlg(params, null, [], false, '凭单 - 选择', function (result) {
                    let postData = {};
                    postData.devcSubNoIdList = [self.devcSubNoId];
                    postData.proofIdList = result.pluck("id");
                    //
                    let theLoad = MsgBox.loading();
                    shopDevcApi.saveShopDeviceMaintProofRel(postData, function (result) {
                        theLoad.hide();
                        if (result.type === "info") {
                            self.$message.success("操作成功");
                            self.getShopDeviceMaintProofRelListBydevcSubNoId();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceMaintProofRelList.vue